import { eulaUpdateStatus } from '../../../../app/types';
import type { ManEulaStatus } from '../../../../services/schemas/accountsBackendCodec';
import { EulaStatusDialog, type EulaStatusDialogConfig } from './EulaStatusDialog';

interface AcceptEulaDialogProps {
    eulaStatus: ManEulaStatus;
}

const acceptEulaDialogConfig: EulaStatusDialogConfig = {
    buttonText: 'Accept EULA',
    confirmationText: 'ACCEPT',
    confirmButtonText: 'Accept',
    dialogTitle: 'Accept EULA',
    errorLogVerb: 'accept',
    errorMessageId: 'intl-msg:helpgang.notification.couldNotAcceptEula',
    isButtonDisabled: status => status === 'ACCEPTED',
    successMessageId: 'intl-msg:helpgang.notification.acceptEulaSuccess',
    targetStatus: eulaUpdateStatus.ACCEPTED,
};

export const AcceptEulaDialog = ({ eulaStatus }: AcceptEulaDialogProps) => (
    <EulaStatusDialog config={acceptEulaDialogConfig} eulaStatus={eulaStatus} />
);
